export const getSessionState = (stateName: string) => {
  try {
    const persistedState = window.sessionStorage.getItem(stateName);

    if (persistedState) {
      return JSON.parse(persistedState);
    } else {
      return;
    }
  } catch (e) {
    console.log(e);
  }
};

export const setSessionState = (stateName: string, state: unknown) => {
  try {
    return window.sessionStorage.setItem(stateName, JSON.stringify(state));
  } catch (e) {
    console.log(e);
  }
};
